export default "__VITE_ASSET__DQET_IIN__"